import React from 'react';
import PropTypes from 'prop-types';
import Social from '../../services/social.service';
import './styles.css';

const SocialBlock = ({ socials, login, t, register }) => (
  <React.Fragment>
    <ul className="social-auth-block">
      {
      socials.map(({ title, name, icon, connected }, index) => (
        <React.Fragment key={name}>
          <li className={socials.length === 1 ? 'without-padding' : ''}>
            <a href={Social.getSocialAuthHREF(name)}>
              <i className={`${icon} social-auth-login ${connected ? 'active' : ''}`} />
              { (login || register) && <span>{title}</span> }
            </a>
          </li>
          { (login || register) && ((index + 1) < socials.length) && <li className="hideMobile">{t('or')}</li> }
        </React.Fragment>
      ))
      }
    </ul>
  </React.Fragment>);

const ClassicSocialBlock = ({ socials, login, register, t}) => (
  <ul className="classic-social-buttons">
    {socials.map(({ title, name, icon, connected }) => (
      <li className="btn-block" key={name}>
        <a
          href={Social.getSocialAuthHREF(name)}
          className={`btn btn-block btn-social btn-sm btn-${name.toLowerCase()} ${connected ? 'active' : ''}`}
        >
          <i className={icon} />
          {!!login && t('Login with')}
          {!!register && t('Register with')}
          {' '}
          {title}
        </a>
      </li>
    ))}
  </ul>
);

const SocialAuth = ({ t, socials = [], login, login_modules_theme, register }) => (
  <React.Fragment>
    {(login_modules_theme === 1) && (
      <React.Fragment>
        {(socials.length > 0 && login) ? <div className="hide560 boxs" style={{ marginTop: '10px' }}>{t('or login with')}</div> : ''}
        {(socials.length > 0 && register) ? <div className="hide560 boxs" style={{ marginTop: '10px' }}>{t('or register with')}</div> : ''}
        <div className="loginwith boxs" style={{ paddingTop: '30px' }}>
          <SocialBlock socials={socials} login={login} t={t} register={register} />
        </div>
      </React.Fragment>
    )}
    {(login_modules_theme === 2) && (
      <React.Fragment>
        {(socials.length > 0) ? <div className="hide560 boxs" style={{ marginTop: '5px', paddingBottom: '15px' }}>{t('or')}</div> : ''}
        <ClassicSocialBlock socials={socials} login={login} t={t} register={register} />
      </React.Fragment>
    )}
  </React.Fragment>
);

SocialAuth.propTypes = {
  socials: PropTypes.array.isRequired,
};

export default SocialAuth;




// WEBPACK FOOTER //
// ./src/components/socialAuth/SocialAuth.js